import t from "@/lang/lang";

/** Mirrors `positions.Category`, backend/core/omni/domain/positions/category.go. */
export const PositionCategory = {
  Zero: "",
  Incidental: "incidental",
  Treatment: "treatment",
  Product: "product",
  External: "external",
};

export type PositionCategory =
  (typeof PositionCategory)[keyof typeof PositionCategory];

export const PositionCategoryList = Object.values(PositionCategory);

export const PositionCategorySelectItems = [
  { value: PositionCategory.Zero, label: t("Ohne") },
  { value: PositionCategory.Treatment, label: t("Behandlung") },
  { value: PositionCategory.Incidental, label: t("Nebenkosten") },
  { value: PositionCategory.Product, label: t("Produkt") },
  { value: PositionCategory.External, label: t("Extern") },
];
